<template><svg xmlns="http://www.w3.org/2000/svg" width="14.269" height="14.266" viewBox="0 0 14.269 14.266">
    <g transform="translate(0.135 0.132)">
        <rect width="14" height="14" fill="none"/>
        <path d="M212.618,1668.74l4.128-4.128a2.558,2.558,0,0,0,3.411-3.411l-.8.8a.852.852,0,1,1-1.206-1.205l.8-.8a2.558,2.558,0,0,0-3.408,3.411l-4.128,4.127a2.558,2.558,0,0,0-3.411,3.411l.8-.8a.852.852,0,1,1,1.206,1.206l-.8.8a2.558,2.558,0,0,0,3.408-3.411Z"
              transform="translate(-207.08 -1659.073)" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" stroke="currentColor"/>
    </g>
</svg>
</template>